import User from '../../js/user'
import req from '../../js/req'
const user = {
   state:() => {
     //  eslint-disable-next-line no-unused-labels
     uid: ""
     //  eslint-disable-next-line no-unused-labels
     token: ""
      //  eslint-disable-next-line no-unused-labels
     info: null
      //  eslint-disable-next-line no-unused-labels
     unread_message: null
     //  eslint-disable-next-line no-unused-labels
     search_str: ""
   },
   mutations:{

      updateLoginUserInfo(state, data){
         const { uid, token } = data
         state.uid = uid
         state.token =  token
         User.setUT(uid,token)
      }
   },
   actions:{
      updateLoginUserInfo({ commit },info){
        commit('updateLoginUserInfo', info)
      },
      updateSearchStr({ commit }, str){
         commit('updateUserSearchStr', str)
       },
      loginOut({ commit }){
         commit('updateLoginOut')
      },
      async loadUserInfo({ commit }){
            let user_info = await req.post(req.path.get_user_info, User.getUTP());
            commit('updateLoginUserOtherInfo', user_info)
      },
      async loadUserMessage({ commit }) {
          let message_info = await req.post(req.path.get_unread_message_count, User.getUTP());
          commit('updateUnreadMessage',message_info.total)
      }
   },
   getters:{
      uid : (state) => state.uid,
      token: (state) => state.token,
      info:(state) => state.info,
      unread_message:(state) => state.unread_message,
      search_str: (state) => state.search_str
   }

}
export default user